// START A/B TEST PLGRWEB-1649-add to my list button from mylist page
import { AbTest } from 'abTests/lib/AbTest';
import AddToMyListFromYAML from 'abTests/testClasses/AddToMyListFromYAML';
import HttpService from 'services/HttpService';
import watchListBrowseItem from 'templates/watchListBrowse/__watchListBrowseItem.tpl';
import template from 'templates/carousels/__carousel.tpl';

export default class MyListPageAddToMyList extends AddToMyListFromYAML {
    static contentIds = new Set();

    constructor(swiper) {
        super(CBS?.AbTestsConfigs?.modules?.MyListPageAddToMyList);
        this.implement();
        this._http = new HttpService();
        this.browseGrid = document.querySelector('.watchlist-browse-grid');
        this.recommendedCarouselSwiper = swiper;
        this.setUpSlidesEvent();
        this.onRun();
        this.setCarouselTrackingData(document.getElementById('rfy-hybrid-carousel'));
    }

    /**
     * on user clicking next sldies, set up click events for next slides
     */
    setUpSlidesEvent() {
        const thisClass = this;
        this.recommendedCarouselSwiper.on('slideNextTransitionEnd', function () {
            thisClass.onRun();
        });
        this.recommendedCarouselSwiper.on('slidePrevTransitionEnd', function () {
            if (this.activeIndex === 0) {
                CBS.Registry.lazyImage.revalidate();
            }
        });
    }

    /**
     * set up click events for next slides
     */
    onRun() {
        this.setClickActionsOnWatchCTAWrappers(
            [...this.recommendedCarouselSwiper.slides],
            this.refreshRecommendBasedOnMyListCarousel.bind(this),
            this.removeJustAddedSlideFromBasedOnMyListCarousel.bind(this),
        );
    }

    /**
     * @param evt
     * click handler everytime user adds show/movie from Recommended on My List
     * lazyload to the show/movie that will append to grid
     * prepend just added show/movie to grid
     * remove just added show/movie from  recommended on my list carousel
     */
    refreshRecommendBasedOnMyListCarousel(evt) {
        this._http
            .doGet(CBS.Registry.region.prefix + '/carousels/getRecommendedShowsXHR/')
            .then((addToMyListResp) => {
                const gridWatchListItems = addToMyListResp?.data?.result?.dataCi?.data;
                if (gridWatchListItems) {
                    const updatedGridWatchListItems = [];
                    $(gridWatchListItems).each(function () {
                        updatedGridWatchListItems.push(watchListBrowseItem($(this)[0]));
                    });

                    // Update grid
                    if (
                        !$(this.browseGrid).find('#' + $(updatedGridWatchListItems[0])[0].id).length
                    ) {
                        $(this.browseGrid).html(updatedGridWatchListItems);
                    }

                    CBS.Registry.lazyImage.load(this.browseGrid.firstChild.querySelector('img'));
                    CBS.Registry.lazyImage.revalidate();

                    //  build recommended carousel data in json for js to prepend the item that does not exists recommended carousel data, no duplicates
                    this.prependSlideToRFYCarousel(addToMyListResp?.data?.result?.data);
                    this.updatePositionColumnValues();
                }
            });
    }

    /**
     * reset position column for each show/movies in the grid
     */
    updatePositionColumnValues() {
        const BrowseItems = this.browseGrid.querySelectorAll('.watchlist-browse-item');
        if (BrowseItems) {
            for (let index = 0; index < BrowseItems.length - 2; index++) {
                const anchor = BrowseItems[index].querySelector('a');
                const aaLink = anchor.getAttribute('aa-link').split('|') ?? [];
                aaLink[1] = index;
                anchor.setAttribute('aa-link', aaLink.join('|'));
            }
        }
    }

    /**
     * @param carouselData
     * prepend new recommend based on my list show/movie by using template function
     * new recommend based on my list show/movie is not currently in the carousel
     */
    prependSlideToRFYCarousel(carouselData) {
        for (let i = 0; i < carouselData.length; i++) {
            const contentId = carouselData[i]?.id;
            //first new recommend based on my list show/movie is not currently in the carousel, ensure no duplicates
            if (!MyListPageAddToMyList.contentIds.has(contentId)) {
                const carouselItem = template({
                    data: [carouselData[i]],
                })
                    .split('<div class="break"></div>')
                    .slice(0, -1);
                //prepend slide
                this.recommendedCarouselSwiper.virtual.prependSlide(carouselItem);
                CBS.Registry.lazyImage.revalidate();
                this.setClickActionsOnWatchCTAWrappers(
                    [this.recommendedCarouselSwiper.slides[0]],
                    this.refreshRecommendBasedOnMyListCarousel.bind(this),
                    this.removeJustAddedSlideFromBasedOnMyListCarousel.bind(this),
                    true,
                );
                MyListPageAddToMyList.contentIds.add(contentId);
                //break to stop for loop
                break;
            }
        }
    }

    /**
     * @param evt
     * remove just added show/movie from recommended based on my list carousel
     * since this show/movie will be in the my list
     */
    removeJustAddedSlideFromBasedOnMyListCarousel(evt) {
        return new Promise((resolve) => {
            const swiperWrapper = evt.target.parentNode.parentNode.parentNode.parentNode.parentNode;
            const indexToRemove = swiperWrapper.getAttribute('data-swiper-slide-index');
            this.recommendedCarouselSwiper.virtual.removeSlide(parseInt(indexToRemove.trim()));
            resolve(
                'remove just added show/movie from recommended based on my list carousel complete',
            );
        });
    }
}

/**
 * @param carouselId: carousel to ensure only Recommended Based on My List
 * @param virtualSlides: set virtualSlides
 * @param carouselWrapper: carousel wrapper to query selector all slides
 * has to force virtual mode like JS build carousels because prependSlide and removeSlide only workson virutal slides
 */
export const forceVirtualSlides = ({ carouselId, virtualSlides, carouselWrapper }) => {
    const slides = carouselWrapper.querySelectorAll('.swiper-slide');
    virtualSlides = [];
    slides.forEach((html) => {
        const contentId = html.querySelector('a.link').getAttribute('id');
        //JS SET to store contentID so we use this set to ensure no new recomdend show/movie duplicates can be added Recommended Based on My List carousel
        MyListPageAddToMyList.contentIds.add(contentId.trim());
        virtualSlides.push(html.innerHTML);
    });

    return virtualSlides;
};

// END A/B TEST PLGRWEB-1649-add to my list button from mylist page
